// extracted by mini-css-extract-plugin
export default {"input":"idk-field_input__ZMlMA","inpInner":"idk-field_inpInner__A8yqj"};